export const neonnight = {
  name: 'Neon Night',
  color: [0.1450980392156863, 0.5019607843137255, 0.2235294117647059, 1],
  bg: [0.9686274509803922, 0.4627450980392157, 0.01568627450980392, 1],
  grid1: [0.9607843137254902, 0.4235294117647059, 0.3411764705882353, 1],
  grid2: [0.13725490196078433, 0.10588235294117647, 0.07058823529411765, 1],
}
